import {SessionInfoStateType} from 'module/SessionInfo/reducer/SessionInfoReducer';

export const selCurrentUser = (state: SessionInfoStateType) => state.SessionInfo.data?.evoAppsUser;

export const selCurrentUsername = (state: SessionInfoStateType) => state.SessionInfo.data?.evoAppsUser?.username;
export const selCurrentUserPersNr = (state: SessionInfoStateType) => state.SessionInfo.data?.evoAppsUser?.persNr;

export const selSessionInfoData = (state: SessionInfoStateType) => state.SessionInfo.data
export const selSessionInfoExpanded = (state: SessionInfoStateType) => state.SessionInfo.expanded